var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "gfu-launch-project-box _bxsh--base",
      attrs: {
        role: "region",
        "aria-labelledby": "launch-project-box-title",
        "data-qa": "LaunchProjectBox",
      },
    },
    [
      _c("themed-image", {
        staticClass: "gfu-launch-project-box__image",
        attrs: {
          src: "/content/images/static/homepage/rocket.svg",
          alt: "Launch campaign",
          width: "38",
        },
      }),
      _vm._v(" "),
      _c(
        "base-heading",
        {
          staticClass: "gfu-hd gfu-hd--h3 _mr-4 _mb-h _z-2",
          attrs: { id: "launch-project-box-title", tag: "h2" },
        },
        [_vm._v(_vm._s(_vm.Resources.Homepage.StartCampaignBoxHeader))]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "_mt-0 _mb-2 _tc--dark _z-2" }, [
        _vm._v(_vm._s(_vm.Resources.Homepage.StartCampaignBoxDescription)),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--micro",
          attrs: {
            href: _vm.becomeACreatorUrl,
            "aria-label": "Start your campaign",
            "data-qa": "LaunchProjectButton",
          },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.Resources.Homepage.StartCampaignBoxActionLabel) +
              "\n        "
          ),
          _c("base-icon", {
            staticClass: "_ml-1",
            attrs: { name: "chevron-right", "aria-hidden": "true" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }